module.exports = __webpack_public_path__ + "img/aloldal_hatter.808a5eed.png";